// Default Prefix for all types
export const GET = 'GET_';
export const SET = 'SET_';
export const PUT = 'PUT_';
export const DELETE = 'DELETE_'
export const NEW = 'NEW_'